import { render, staticRenderFns } from "./PayeeIndividual.vue?vue&type=template&id=0c160ea7&"
import script from "./PayeeIndividual.vue?vue&type=script&lang=js&"
export * from "./PayeeIndividual.vue?vue&type=script&lang=js&"
import style0 from "./PayeeIndividual.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports